<div class="d-flex justify-content-center align-items-center vh-100 error-container">
  <div class="text-center">
    <h1 class="display-1 text-danger">404</h1>
    <h2>Page Not Found</h2>
    <p class="text-muted">Sorry, the page you are looking for does not exist.</p>
    <button type="button" class="btn btn-primary" [routerLink]="homePagePath">Go to Homepage</button>
  </div>
</div>